import React, { FC, forwardRef, memo } from 'react';
import { StepProps } from './types';
import { SytledStep } from './styles';

const Step: FC<StepProps> = forwardRef<HTMLButtonElement, StepProps>(({
  children,
  onClick,
  disabled,
  active,
  ...restProps
}, ref) => {
  const handleClick = () => {
    if (disabled || !onClick) {
      return;
    }

    onClick();
  };

  return (
    <SytledStep
      ref={ref}
      onClick={handleClick}
      disabled={disabled}
      active={active}
      {...restProps}
    >
      {children}
    </SytledStep>
  );
});

export default memo(Step);
